import { httpClient, HttpMethod } from './http-client';
import {
  CheckInObject,
  CheckOutObject,
  LinkObject,
  Technician,
} from '../@types/service.type';

export const getServiceCheckIn = (id: number): Promise<CheckInObject> => {
  return httpClient<CheckInObject>(`/services/${id}/checkins/single`, HttpMethod.Get);
};

export const createServiceCheckIn = (data: CheckInObject): Promise<CheckInObject> => {
  return httpClient<CheckInObject>('/checkin', HttpMethod.Post, data);
};

export const updateServiceCheckOut = (id: number, data: CheckOutObject): Promise<CheckInObject> => {
  return httpClient<CheckInObject>(`/checkin/${id}/checkout`, HttpMethod.Put, data);
};

export const getServiceListByTechnician = (): Promise<LinkObject> => {
  return httpClient<LinkObject>('/checkin/sibling/services', HttpMethod.Get);
};

export const getTechnicianListByLocationNodeId = (locationNodeId: number): Promise<Technician[]> => {
  return httpClient<Technician[]>(`/checkin/technicians/${locationNodeId}`, HttpMethod.Get);
};

export const createBulkServiceCheckInQuery = (data: CheckInObject[]): Promise<CheckInObject[]> => {
  return httpClient<CheckInObject[]>('/bulkcheckin', HttpMethod.Post, data);
};
